var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1205 13.53C12.1005 13.53 12.0705 13.53 12.0505 13.53C12.0205 13.53 11.9805 13.53 11.9505 13.53C9.68047 13.46 7.98047 11.69 7.98047 9.51001C7.98047 7.29001 9.79047 5.48001 12.0105 5.48001C14.2305 5.48001 16.0405 7.29001 16.0405 9.51001C16.0305 11.7 14.3205 13.46 12.1505 13.53C12.1305 13.53 12.1305 13.53 12.1205 13.53ZM12.0005 6.97001C10.6005 6.97001 9.47047 8.11001 9.47047 9.50001C9.47047 10.87 10.5405 11.98 11.9005 12.03C11.9305 12.02 12.0305 12.02 12.1305 12.03C13.4705 11.96 14.5205 10.86 14.5305 9.50001C14.5305 8.11001 13.4005 6.97001 12.0005 6.97001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 22.75C9.30984 22.75 6.73984 21.75 4.74984 19.93C4.56984 19.77 4.48984 19.53 4.50984 19.3C4.63984 18.11 5.37984 17 6.60984 16.18C9.58984 14.2 14.4198 14.2 17.3898 16.18C18.6198 17.01 19.3598 18.11 19.4898 19.3C19.5198 19.54 19.4298 19.77 19.2498 19.93C17.2598 21.75 14.6898 22.75 11.9998 22.75ZM6.07984 19.1C7.73984 20.49 9.82984 21.25 11.9998 21.25C14.1698 21.25 16.2598 20.49 17.9198 19.1C17.7398 18.49 17.2598 17.9 16.5498 17.42C14.0898 15.78 9.91984 15.78 7.43984 17.42C6.72984 17.9 6.25984 18.49 6.07984 19.1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.0366f0b6dc60463a3307a9df4e68408f.svg";
export { ForwardRef as ReactComponent };